var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2095 25.4293C3.81931 22.7279 1.875 18.6942 1.875 14.3624C1.875 10.0308 3.81919 5.99711 7.20925 3.29574C7.61419 2.97305 7.68081 2.38317 7.35813 1.9783C7.0355 1.57336 6.44563 1.50667 6.04069 1.82936C2.20175 4.88855 0 9.45667 0 14.3624C0 19.2684 2.20181 23.8365 6.041 26.8957C6.44569 27.2182 7.03562 27.1518 7.35844 26.7467C7.68106 26.3418 7.61444 25.752 7.2095 25.4293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9594 1.82946C25.5544 1.50683 24.9647 1.57346 24.642 1.97839C24.3193 2.38333 24.3859 2.97314 24.7909 3.29583C28.1808 5.99727 30.125 10.0309 30.125 14.3625C30.125 18.6941 28.1808 22.7277 24.7908 25.4291C24.3859 25.7518 24.3193 26.3416 24.6419 26.7465C24.9648 27.1516 25.5547 27.2179 25.9594 26.8955C29.7983 23.8363 32 19.2681 32 14.3625C32 9.45677 29.7983 4.88864 25.9594 1.82946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 21.516C8.13556 19.7678 6.875 17.1604 6.875 14.3624C6.875 11.5643 8.13556 8.95688 10.3335 7.20863C10.7387 6.88632 10.8059 6.29657 10.4836 5.89132C10.1612 5.48607 9.57144 5.41888 9.16625 5.74119C6.51856 7.84725 5 10.9895 5 14.3624C5 17.7352 6.51856 20.8774 9.16619 22.9834C9.57169 23.3059 10.1613 23.2384 10.4835 22.8333C10.8058 22.4281 10.7386 21.8383 10.3334 21.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8338 5.74141C22.4286 5.41916 21.8389 5.48628 21.5165 5.89153C21.1942 6.29672 21.2614 6.88653 21.6666 7.20885C23.8644 8.95703 25.125 11.5644 25.125 14.3625C25.125 17.1605 23.8644 19.768 21.6665 21.5162C21.2613 21.8385 21.1941 22.4282 21.5164 22.8335C21.8389 23.2389 22.4288 23.3057 22.8337 22.9836C25.4814 20.8775 27 17.7353 27 14.3625C27 10.9897 25.4814 7.84741 22.8338 5.74141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.6875C13.4153 9.6875 11.3125 11.7903 11.3125 14.375C11.3125 16.6387 12.9255 18.5326 15.0625 18.9682V29.4375C15.0625 29.9552 15.4823 30.375 16 30.375C16.5177 30.375 16.9375 29.9552 16.9375 29.4375V18.9682C19.0745 18.5327 20.6875 16.6388 20.6875 14.375C20.6875 11.7903 18.5847 9.6875 16 9.6875ZM16 17.1875C14.4492 17.1875 13.1875 15.9258 13.1875 14.375C13.1875 12.8242 14.4492 11.5625 16 11.5625C17.5508 11.5625 18.8125 12.8242 18.8125 14.375C18.8125 15.9258 17.5508 17.1875 16 17.1875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP3);
export default __webpack_public_path__ + "static/media/p3.6da7d0afadbee0033eb6f4d3cc5934e8.svg";
export { ForwardRef as ReactComponent };